import { toastr } from 'react-redux-toastr';

import { ApiErrorCode } from '../api/errors';

export const getErrorMessage = (title: string, errorCode: ApiErrorCode) => {
  switch (errorCode) {
    case 26:
      toastr.error(title, 'Пользователь с указанным email не найден');
      break;
    case 3:
      toastr.error(title, 'Вход в систему не удался');
      break;
    default:
      toastr.error(title, 'Неизвестная ошибка');
      break;
  }
};
